<template>
  <div class="row">

    <div class="col-md-12 col-xs-12">
      <loading v-if="! showContent"></loading>
      <div v-if="itemsList" class="product-slider">
        <div id="carousel" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div :class="index == 0 ? 'item active' : 'item'" v-for="(item, index) in itemsList">
              <a :href="returnLink(item)" v-if="!isPage(item)" :target="linkBlank(item)"  >
                <img :src="item.image" class="img-responsive">
              </a>
              <router-link :to="item.link" v-if="isPage(item)">
                <img :src="item.image" class="img-responsive">
              </router-link>
            </div>
          </div>
          <a class="left carousel-control" href="#carousel" role="button" data-slide="prev"> <i
                  class="fa fa-angle-left" aria-hidden="true"></i> </a>
          <a class="right carousel-control" href="#carousel" role="button" data-slide="next"><i
                  class="fa fa-angle-right" aria-hidden="true"></i> </a>
        </div>
        <div class="clearfix">
          <div id="thumbcarousel" class="carousel slide" data-interval="false">
            <div class="carousel-inner">
              <div :class="index == 0 ? 'item active' : 'item'" v-for="(item, index) in thumbsList">
                <div data-target="#carousel" v-for="(destaque, ind) in item" :data-slide-to="destaque.id" class="thumb">
                  <img :src="destaque.thumb">
                </div>
              </div>
            </div>
            <a class="left carousel-control" href="#thumbcarousel" role="button" data-slide="prev">
              <i  class="fa fa-angle-left" aria-hidden="true"></i>
            </a>
            <a class="right carousel-control" href="#thumbcarousel" role="button" data-slide="next">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import Vue from 'vue';


  export default {
    components: {
      Loading,
    },
    props: ['bloco'],
    data() {
      return {
        showContent: false,
        title: '',
        itemsList: [],
        thumbsList: [],
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      get('content/' + this.bloco.id).then(function (response) {

        self.showContent = true;
        self.itemsList = response.data.result.data.destaques;
        self.thumbsList = response.data.result.data.thumbs;
      });
      // self.itemsList = window.siteconfig.result.data.slider;
      // self.showContent = true;
    },
    mounted() {
    },
    methods: {
      returnLink(item){
        if(item){
          return item.link;
        }
        return '';
      },
      isPage(item) {
        if (item.link_interno == 0) {
          return true;
        }
      },
      linkBlank(item) {
        if (item.openInNewTab == '1') {
          return '_blank'
        }
        return '_self';
      }
      // checkLinkSamePage(item) {
      //   if (item.openInNewTab != '2') {
      //     return true;
      //   }
      // }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Banner.vue